import { PropTypes } from "base/react-libs";

const CareerMoveRowDetails = ({ job, first, subtitle }) => {
  const { title, company, reported } = job;

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
      {first && <div className="homepage-recommendations-subtitle">{subtitle}</div>}
      <div>
        {title} | {company}
      </div>
      <div className="giving-date">Date Reported: {reported}</div>
    </div>
  );
};

CareerMoveRowDetails.propTypes = {
  job: PropTypes.object,
  first: PropTypes.bool,
  subtitle: PropTypes.string,
};

export default CareerMoveRowDetails;
